'use strict';

var AppDialogController = function() {

  return {
    bindToController: true,
    scope: {},
    controller: 'AppDialogsController',
    controllerAs: 'vm',
    link: function() {},
    templateUrl: 'dialogs/appDialogs.tpl.html'
  };
};

module.exports = AppDialogController;


// WEBPACK FOOTER //
// ./src/app/dialogs/AppDialogsDirective.js